// Lead tracker — fire-and-forget the lead capture, then return so the
// WhatsApp redirect happens instantly. Never blocks the user.
//
// Usage from a CTA:
//   onClick={() => trackLead({ stay, context: 'hero_cta' })}
//
// Pulls UTM from the current URL automatically.

const API = process.env.REACT_APP_BACKEND_URL;

const getUtm = () => {
  if (typeof window === 'undefined') return {};
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get('utm_source') || null,
    utm_medium: p.get('utm_medium') || null,
    utm_campaign: p.get('utm_campaign') || null,
  };
};

export function trackLead({ stay = null, context = 'unknown', source = 'stay', enquiry = null } = {}) {
  if (typeof window === 'undefined') return;
  const payload = {
    stay_id: stay?.gohimalayan_id || null,
    stay_name: stay?.display_name || null,
    page: window.location.pathname,
    source,
    context,
    referrer: document.referrer || null,
    user_agent: navigator.userAgent.slice(0, 250),
    ...getUtm(),
    // Structured enquiry fields (only when EnquireModal is used; null otherwise)
    ...(enquiry ? {
      check_in: enquiry.check_in || null,
      check_out: enquiry.check_out || null,
      nights: enquiry.nights ?? null,
      adults: enquiry.adults ?? null,
      children: enquiry.children ?? null,
      rooms: enquiry.rooms ?? null,
      note: enquiry.note || null,
      guest_name: enquiry.guest_name || null,
      guest_phone: enquiry.guest_phone || null,
    } : {}),
  };

  // sendBeacon is the most reliable for tab-close / new-tab cases like WhatsApp
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      navigator.sendBeacon(`${API}/api/leads/track`, blob);
      return;
    }
  } catch (e) { /* fall through to fetch */ }

  // Fallback: fire-and-forget fetch, keepalive so it survives tab close
  fetch(`${API}/api/leads/track`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
}
